import { useEditor } from '@tiptap/react';
import { EditorContent } from '@tiptap/react';
import Image from '@tiptap/extension-image';
import { TaskItem, TaskList } from '@tiptap/extension-list';
import { TextAlign } from '@tiptap/extension-text-align';
import { Typography as TiptapTypography } from '@tiptap/extension-typography';
import { Highlight } from '@tiptap/extension-highlight';
import Emoji, { gitHubEmojis } from '@tiptap/extension-emoji';
import { Subscript } from '@tiptap/extension-subscript';
import { Superscript } from '@tiptap/extension-superscript';
import { Selection } from '@tiptap/extensions';
import Link from '@tiptap/extension-link';
import StarterKit from '@tiptap/starter-kit';
import { TabKeyHandler } from './tab.jsx';
import { useEffect } from 'react';

export default function Editor({ content, editable = true, onChange }) {
  const editor = useEditor({
    editorProps: {
      attributes: {
        autocomplete: 'off',
        autocorrect: 'off',
        autocapitalize: 'off',
      },
    },
    extensions: [
      StarterKit.configure({
        link: {
          openOnClick: false,
          enableClickSelection: true,
        },
      }),
      TextAlign.configure({ types: ['heading', 'paragraph'] }),
      TaskList,
      TaskItem.configure({ nested: true }),
      Highlight.configure({ multicolor: true }),
      Image.configure({ inline: true }),
      TiptapTypography,
      Superscript,
      Subscript,
      Selection,
      Link,
      Emoji.configure({ emojis: gitHubEmojis }),
      TabKeyHandler,
    ],
    content,
    editable,
    immediatelyRender: false,
    shouldRerenderOnTransaction: true,
  });

  useEffect(() => {
    if (editor && content !== editor.getHTML()) {
      editor.commands.setContent(content);
    }
  }, [content]);

  const handleKeyDown = (evt) => {
    // Prevent propagation to avoid interfering with global shortcuts
    evt.stopPropagation();
    if (evt.key === 'Tab') {
      evt.preventDefault();
    }
  };
  return (
    <EditorContent
      editor={editor}
      onKeyDown={handleKeyDown}
      onKeyUp={(evt) => {
        evt.stopPropagation();
        onChange(editor.getHTML());
      }}
    />
  );
}
